module.exports = __webpack_public_path__ + "static/media/logo.e1169da8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logo.svg
// module id = 785
// module chunks = 0